import { NotFound, Organization, truthy } from "@quortex/front-common"
import { type DefaultGenerics, Outlet, type Route } from "@tanstack/react-location"
import { lazy } from "react"
import { ingestRoutes } from "@/routes-ingest"

const Root = lazy(() => import("./App/Root"))

export const portalRoutes: Route<DefaultGenerics> = {
  path: "/",
  element: <Root />,
  children: [
    {
      path: "organizations/:orgUuid",
      element: (
        <Organization>
          <Outlet />
        </Organization>
      ),
      children: [
        // App routes
        ...ingestRoutes,
        { element: <NotFound /> }
      ]
    }
  ].filter(truthy)
}
